export const modalHeaderStyles = {
  paddingBottom: "24px",
};

export const modalBodyStyles = {
  paddingBottom: "24px",
};
